import React, { useState, useEffect } from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import { Input } from 'ui-components/Input'
import { InputPassword } from 'ui-components/InputPassword'
import { Button } from 'ui-components/Button'
import { Alert } from 'ui-components/Alert'
import { requestLogin } from 'requests/login'
import { DASHBOARD } from 'constants/app-paths'
import { saveAuthToken } from 'storage'
import { isLoggedIn } from 'utils/logged'
import {
  LoginContainer,
  LoginForm,
  ButtonContainer,
} from './styles'

export default function Login() {
  const [login, setLogin] = useState({ email: '', password: '' })
  const [errorMessage, setErrorMessage] = useState('')
  const history = useHistory()
  const { state } = useLocation()

  useEffect(() => {
    if (isLoggedIn()) history.push(DASHBOARD)
  }, [history])

  const onChange = (evt) => {
    const { value, name } = evt.target
    setLogin({
      ...login,
      [name]: value,
    })
  }

  const onSubmit = async (evt) => {
    evt.preventDefault()

    if (!login.email.length || !login.password.length) {
      return setErrorMessage('Informe todos os campos')
    }

    const response = await requestLogin({ user: login })
    if (response.status !== 200) {
      return setErrorMessage('Login inválido')
    }

    saveAuthToken(response.headers.authorization)
    const path = state?.from?.pathname || DASHBOARD
    return history.push(path)
  }

  const renderErrorMessage = () => (
    <Alert severity="error">
      {errorMessage}
    </Alert>
  )

  return (
    <LoginContainer>
      <LoginForm>
        <form onSubmit={onSubmit}>
          { errorMessage.length ? renderErrorMessage() : null }
          <Input
            label="E-mail"
            type="email"
            name="email"
            fullWidth
            required
            margin="normal"
            value={login.email}
            onChange={onChange}
          />
          <InputPassword
            password={login.password}
            onChange={onChange}
          />
          <ButtonContainer>
            <Button
              type="submit"
              fullWidth
              variant="contained"
              color="primary"
              onClick={onSubmit}
            >
              LOGIN
            </Button>
          </ButtonContainer>
        </form>
      </LoginForm>
    </LoginContainer>
  )
}
